import React, { PropsWithChildren, useRef } from 'react';
import classNames from 'classnames';
import { Paper, Popper } from '@mui/material';

import BubbleCount from 'components/Listing/Filters/BubbleCount/BubbleCount';
import SelectionButton from 'components/Listing/Common/SelectionButton/SelectionButton';

import styles from './FilterPopper.module.scss';

type PropsType = PropsWithChildren<{
  label: string;
  open: boolean;
  onClick: () => void;
  appliedCount?: number;
  classes?: ClassesType;
}>;
type ClassesType = { paper?: string };

export default function FilterPopper({
  children,
  label,
  open,
  onClick,
  appliedCount,
  classes,
}: PropsType): JSX.Element {
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <SelectionButton
        ref={containerRef}
        label={label}
        open={open}
        onClick={onClick}
      >
        {appliedCount && (
          <BubbleCount count={appliedCount} className={styles.bubbleCount} />
        )}
      </SelectionButton>
      <Popper
        open={open}
        anchorEl={containerRef.current}
        placement="bottom-start"
        disablePortal
        modifiers={[
          {
            name: 'flip',
            enabled: false,
          },
        ]}
        className={styles.popover}
      >
        <Paper className={classNames(styles.paper, classes?.paper)}>
          {children}
        </Paper>
      </Popper>
    </>
  );
}
